<template>
  <a-button class="plain-btn" @click="onClick" v-bind="$attrs">
    <template #icon>
      <slot name="icon"></slot>
    </template>
    <slot></slot>
  </a-button>
</template>

<script lang="ts" setup>
import { defineEmits } from "vue";

const emit = defineEmits(["click"]);
const onClick = (e: MouseEvent) => {
  emit("click", e);
};
</script>

<script lang="ts">
export default {
  name: "PlainButton"
};
</script>

<style lang="less" scoped>
.plain-btn {
  background-color: rgba(240, 247, 255, 1);
  border-color: rgba(122, 187, 255, 1);
  color: @primary;
  &:hover {
    background-color: @primary;
    border-color: @primary;
    color: #fff;
  }
}
</style>
